<div class="col-12  white-background common-border-radius accordian">
  <p-fieldset [toggleable]="true" icon="fa fa-filter" [title]="'label_filters'| translate"
    (onAfterToggle)="onAfterToggle($event)" [collapsed]="collapsed">
    <div class="col-12 p-0 grid">
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>lbl_dispatch_zones</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-multiSelect
            [options]="serviceCitiesOptions"
            [(ngModel)]="selectedDispatchAddress"
            (onChange)="changeFilter('selectedDispatchAddress',selectedDispatchAddress)"
            [filter]="true"
            maxSelectedLabels="0"
            [selectedItemsLabel]="selectedDispatchAddress.length === 1 ? '{0} item' : '{0} items'"
            [placeholder]="'label_all' | translate">
          </p-multiSelect>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>lbl_pickup_location</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-multiSelect
            [options]="pickupLocationsOptions"
            [(ngModel)]="selectedPickupLocation"
            (onChange)="changeFilter('selectedPickupLocation',selectedPickupLocation)"
            [placeholder]="pickupDropPlaceHolder"
            [filter]="true"
            maxSelectedLabels="0"
            [selectedItemsLabel]="selectedPickupLocation.length === 1 ? '{0} item' : '{0} items'">
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>lbl_drop_location</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-multiSelect
            [options]="pickupLocationsOptions"
            [(ngModel)]="selectedDropLocation"
            (onChange)="changeFilter('selectedDropLocation',selectedDropLocation)"
            [placeholder]="pickupDropPlaceHolder"
            [filter]="true"
            maxSelectedLabels="0"
            [selectedItemsLabel]="selectedDropLocation.length === 1 ? '{0} item' : '{0} items'">
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_from_date_filter</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-calendar #rangePicker [(ngModel)]="fromDate" [dateFormat]="dateFormat" [showIcon]="true" readonlyInput="true"
            (onSelect)="onSelectDates($event,'fromDate')">
          </p-calendar>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_to_date_filter</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-calendar #rangePicker [(ngModel)]="toDate" [dateFormat]="dateFormat" [showIcon]="true" [minDate]="minDate"
            readonlyInput="true" (onSelect)="onSelectDates($event,'toDate')">
          </p-calendar>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="serviceType" translate>label_vehicle_type</label>
        </div>
        <div class="form-control">
          <p-multiSelect [style]="{'width': '100%'}" [options]="vehicleTypeOptions" [(ngModel)]="selectedVehicleTypeId"
            (onChange)="changeFilter('selectedVehicleTypeId',selectedVehicleTypeId)"
            maxSelectedLabels="0" [selectedItemsLabel]="selectedVehicleTypeId.length === 1 ? '{0} item' : '{0} items'"
            [placeholder]="'label_all' | translate">
          </p-multiSelect>
        </div>
      </div>
    </div>

    <div class="col-12 p-0 grid">


      <div class="col-12 md:col-2 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_status</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-multiSelect
            [options]="statusListFilterOptions"
            [(ngModel)]="selectedBookingStatus"
            maxSelectedLabels="0"
            (onChange)="changeFilter('selectedBookingStatus',selectedBookingStatus)"
            [selectedItemsLabel]="selectedBookingStatus.length === 1 ? '{0} item' : '{0} items'"
            [placeholder]="'label_all' | translate">
          </p-multiSelect>
        </div>
      </div>

      <div class="col-12 md:col-2 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_sort_by_list</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-dropdown [options]="sortTypeOptions" [(ngModel)]="selectedSortType"
            (onChange)="changeFilter('selectedSortType',selectedSortType)">
          </p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-2 lg:col-2" *ngIf="showETAFilter">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_drop_off_in</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-dropdown [options]="etaTimeOptions" [(ngModel)]="nextAvailableTime"
            (onChange)="changeFilter('nextAvailableTime',nextAvailableTime)">
          </p-dropdown>
        </div>
      </div>

      <div [ngClass]="showETAFilter ? 'col-12 md:col-6 lg:col-6' : 'col-12 md:col-8 lg:col-8'">
        <div class="form-label">
          <label for="endtDate">&nbsp;</label>
        </div>
        <button [ngClass]="filterApplied? 'filter-btn-apply filter-applied' : 'filter-btn-apply'" pButton appRipple
          (click)="onclickFilterApply()" type="button" icon="fa fa-check" [label]="'label_apply' | translate"></button>
        <button pButton appRipple class="reset-btn" (click)="resetFilter()" type="button" icon="fa fa-undo"
          [label]="'label_reset' | translate"></button>
      </div>
    </div>
  </p-fieldset>

  <div class="col-12 p-0 pt-2" *ngIf="loadGrid()">
    <app-mi-grid-v2 [url]="url" [columnDefs]="columns" [paginationPageSize]="paginationCount" [overflowShow]="true"
      [uniqId]="uniqId" [searchPlaceHolder]="searchPlaceHolder" [urlMethod]="urlMethod" [bodyMapping]="bodyMapping"
      appLogicalAccessProvider
      accessCode="VIEW_CRITICAL_BOOKINGS" accessGroupCode="CURRENT_BOOKINGS" (rowClickedEvent)="onRowClicked($event)"
      (totalCount)="totalCount($event)" rowSelection="multiple" (dropDownEvent)="changeBookingStatus($event)"
      (clickEtaEmmiter)="getLatestEta($event)" (editClickEvent)="changeDispatchLocation($event)" divClass="mi-grid"
      [gridScrollHeight]="gridScrollHeight" [showActionLegend]="true"></app-mi-grid-v2>
  </div>
</div>

@if(hasShowDriverSideBar){
  <app-assign-driver-v2 [(visible)]="hasShowDriverSideBar" [bookingId]="bookingDetails?.id"
  (sideBarHide)="sideBarHideFromShaired()"></app-assign-driver-v2>
}

<p-dialog modal="true" position="center" autoResize="false" styleClass="assign-search dispatch-location-dialog-div"
  [(visible)]="bookingCancelsPopup" [contentStyle]="{'overflow':'auto','width':'700px','padding-top': '0px'}">
  <p-header class="key-text1">
    {{selectParkingLocationHeader}}
  </p-header>
  <div class="form-container scroll-bar-css scroll-dialog-div">
    <form class="col-12">
      <div class="form-field">
        <div class="form-control">
          <div class="col-12">
            <div class="col-12 md:col-12 lg:col-12 grid">
              <div class="col-3 md:col-3 lg:col-3 key-text" translate>label_parking_locations</div>
              <div class="col-3 md:col-4 lg:col-4 key-text" translate>ETA(Estimated Time Of Arrival)</div>
              <div class="col-3 md:col-2 lg:col-2 key-text" translate>label_distance</div>
              <div class="col-3 md:col-2 lg:col-2 key-text marg-l-8px" translate>grid_actions</div>
            </div>
            <div class="col-12 md:col-12 lg:col-12 ss1 grid" [ngClass]="selectedClass(eachLocation)"
              *ngFor="let eachLocation of dispatchLocations">
              <div class="col-3 md:col-3 lg:col-3">{{eachLocation.displayAddress}}</div>
              <div class="col-4 md:col-4 lg:col-4">{{eachLocation.etaString?eachLocation.etaString:'--'}}</div>
              <div class="col-2 md:col-2 lg:col-2">{{eachLocation.distanceString?eachLocation.distanceString:'--'}}
              </div>
              <div class="col-1 md:col-1 lg:col-1 col-offset-1">
                <button appAccessProvider pButton appRipple type="button" label="Select"
                  [disabled]="selectedClass(eachLocation)" (click)="onSelectDispatchLocation(eachLocation)"></button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-12  form-buttons">
      </div>
    </form>
  </div>
</p-dialog>

<p-dialog [header]="'label_cancel_booking' | translate" [(visible)]="showCustomDialog" [modal]="true"
  styleClass="cancel_luggage_popup" position="center center" responsive="true"
  [contentStyle]="{'overflow':'auto', 'border-radius': 0, 'max-height': '60vh'}" class="cancel-booking-popup">
  <div class="col-12 cancel-booking">
    <p-table class="table-cancel-booking" [value]="bookingToCancel" [(selection)]="selectedBookingToCancel"
      dataKey="tripId">
      <ng-template pTemplate="header">
        <tr>
          <th>
            <p-tableHeaderCheckbox [disabled]="showHideSelectAll"></p-tableHeaderCheckbox>
          </th>
          <th translate>label_BookingId</th>
          <th translate>label_booking_status</th>
          <th translate>label_driver_info</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-associateBooking>
        <tr>
          <td>
            <p-tableCheckbox [value]="associateBooking"
              [disabled]="isBookingDisabled(associateBooking.tourStatus)"></p-tableCheckbox>
          </td>
          <td>{{ associateBooking.tripId }}</td>
          <td>{{ associateBooking.tourStatusStr }}</td>
          <td>
            <ng-container
              *ngIf="associateBooking.driverName || associateBooking.vehicleCode || associateBooking.vehicleRegistration || associateBooking.vehicleMakeModel || associateBooking.vehicleModelName; else noData">
              <div class="driver-name" *ngIf="associateBooking.driverName">
                {{ associateBooking.driverName }}
              </div>
              <div class="vehicle-code" *ngIf="associateBooking.vehicleCode">
                {{ associateBooking.vehicleCode }} - {{ associateBooking.vehicleRegistration }}
              </div>
              <div class="vehicle-make" *ngIf="associateBooking.vehicleMakeModel">
                {{ associateBooking.vehicleMakeModel }} | {{ associateBooking.vehicleModelName }}
              </div>
            </ng-container>
            <ng-template #noData> NA </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-12 grid align-items-center">
    <div class="col-1 pl-3">
      <img src="/assets/images/temp/canel-booking-warning-icon.svg" alt="img">
    </div>
    <div class="col-11 cancel-info">
      You cannot cancel the booking whose status is <span style=" font-weight: 900;">On Trip / Completed.</span>
      Do you wish to proceed?
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div>
      <button class="negative-button" pButton appRipple type="button" [label]="'label_cancel' | translate"
        (click)="closeCancellation()"></button>
      <button class="confirmBtn" pButton appRipple type="button" [label]="'label_submit' | translate"
        [disabled]="selectedBookingToCancel.length === 0" (click)="confirmCustomCancellation()"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [header]="'label_cancel_booking' | translate" [(visible)]="cancellationReason" [modal]="true"
  styleClass="cancel_luggage_popup" position="center center" responsive="true"
  [contentStyle]="{'overflow':'visible', 'border-radius': 0}" class="cancel-popup-footer">

  <div>
    <p class="label_luggage_booking_cancellation">{{label_luggage_booking_cancellation}}</p>
  </div>

  <div *ngIf="showRadioBtn">
    <div class="flex align-items-center">
      <p-radioButton name="cancellation" value="currentBooking" [(ngModel)]="bookingCancel"
        inputId="singleCancelBooking"></p-radioButton>
      <label for="singleCancelBooking" class="ml-2 radioTitle">Cancel Luggage Booking Only</label>
    </div>

    <div class="flex align-items-center">
      <p-radioButton name="cancellation" value="bothBooking" [(ngModel)]="bookingCancel"
        inputId="bothBookingCancel"></p-radioButton>
      <label for="bothBookingCancel" class="ml-2 radioTitle">Cancel Both Bookings</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div>
      <button class="negative-button" pButton appRipple type="button" [label]="'label_cancel' | translate"
        (click)="closeCancellationReason()"></button>

      <button class="confirmBtn" pButton appRipple type="button" [label]="'label_confirm' | translate"
        (click)="confirmCancellationReason()"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="isReview" [modal]="true" styleClass="review_popup" position="center" responsive="true"
  [contentStyle]="{'overflow':'visible', 'border-radius': 0, 'min-height': '500px'}" class="review_popup">
  <p-header style="text-align: center;">
    <label style="font-size: 17px;" translate>label_review_booking</label>
  </p-header>
  <ng-container *ngIf="loading; else bookingDetailsTemplate">
    <div class="progress-loader-review"></div>
  </ng-container>
  <ng-template #bookingDetailsTemplate>
    <div class="col-12 booking-grid-table booking-details pad-top greyBox mb-3">
      <div class="col-12">
        <div class="bookingTime mb-2">{{bookingInfo?.tourBookingInfo?.pickupDateTimeStr}}</div>
      </div>
      <div class="col-12 grid">
        <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
          <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
          <div class="divider"></div>
          <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
        </div>
        <div class="col-10 md:col-10 lg:col-10 passenger-name">
          <div class="passenger-name">
            <label for="companyId" class="label" translate>lbl_pickup_location</label>
            <div class="mt-1 label_value">{{bookingInfo?.tourBookingInfo?.pickupLocationName}}</div>
          </div>
          <div class="pickup-date drop-adr opa-9">
            <label for="companyId" class="label" translate>lbl_drop_location</label>
            <div class="mt-1 label_value">{{bookingInfo?.tourBookingInfo?.dropLocationName}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 booking-grid-table booking-details pad-top greyBox grid ml-0 p-0">
      <div class="col-6 md:col-6 lg:col-6">
        <div class="header inner-header p-2">
          <ng-container *ngIf="bookingInfo?.tourBookingInfo?.subServiceType === 'SHUTTLE'; else passengerDetailsLabel">
            <label class="lbl-heading subHeading" translate>label_group_booking_details</label>
          </ng-container>
          <ng-template #passengerDetailsLabel>
            <label class="lbl-heading subHeading" translate>label_passenger_details</label>
          </ng-template>
        </div>
        <div class="col-12 grid p-0 pl-2" *ngIf="bookingInfo?.tourBookingInfo?.subServiceType !== 'SHUTTLE'">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_passenger_name</label>
          </div>
          <div class="col-12 md:col-5 lg:col-5">
            <label class="lbl-bold">{{bookingInfo?.tourBookingInfo?.pFirstName + ' ' +
              bookingInfo?.tourBookingInfo?.pLastName}}</label>
          </div>
        </div>
        <div class="col-12 grid p-0 pl-2" *ngIf="bookingInfo?.tourBookingInfo?.subServiceType !== 'SHUTTLE'">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_mobile_no</label>
          </div>
          <div class="col-12 md:col-5 lg:col-5">
            <label class="lbl-bold">{{bookingInfo?.tourBookingInfo?.pPhoneNum ?
              (bookingInfo?.tourBookingInfo?.pNumCountryCode + bookingInfo?.tourBookingInfo?.pPhoneNum) :
              defaultNullString}}</label>
          </div>
        </div>
        <div class="col-12 grid p-0 pl-2" *ngIf="bookingInfo?.tourBookingInfo?.subServiceType !== 'SHUTTLE'">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_transport_privilege</label>
          </div>
          <div class="col-12 md:col-5 lg:col-5">
            <label class="lbl-bold">{{bookingInfo?.tourBookingInfo?.passengerType ?
              bookingInfo?.tourBookingInfo?.passengerType : defaultNullString}}</label>
          </div>
        </div>
        <div class="col-12 grid p-0 pl-2" *ngIf="bookingInfo?.tourBookingInfo?.subServiceType === 'SHUTTLE'">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_group_name</label>
          </div>
          <div class="col-12 md:col-5 lg:col-5">
            <label class="lbl-bold">{{bookingInfo?.tourBookingInfo?.tripTitle ?
              bookingInfo?.tourBookingInfo?.tripTitle : defaultNullString}}</label>
          </div>
        </div>
        <div class="col-12 grid p-0 pl-2">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_for_review_popup_luggage_vehicle_required</label>
          </div>
          <div class="col-12 md:col-5 lg:col-5">
            <label class="lbl-bold">{{bookingInfo?.tourBookingInfo?.luggageVehicleRequire ?
              "Yes" : "No"}}</label>
          </div>
        </div>
      </div>

      <div class="col-6 md:col-6 lg:col-6">
        <div class="header inner-header p-2">
          <label class="lbl-heading subHeading" translate>label_journey_details</label>
        </div>

        <div class="col-12 grid p-0 pl-2">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_total_num_of_passengers</label>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <label class="lbl-bold">{{bookingInfo?.tourBookingInfo?.totalNoOfPassengers}}</label>
          </div>
        </div>

        <div class="col-12 grid p-0 pl-2">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_baby_seats</label>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <label class="lbl-bold"
              [ngClass]="[bookingInfo?.tourBookingInfo?.totalNoOfBabyseats > 0?'color-green count-font':'']">
              {{bookingInfo?.tourBookingInfo?.totalNoOfBabyseats}}</label>
          </div>
        </div>

        <div class="col-12 grid p-0 pl-2">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_wheelchair</label>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <label class="lbl-bold">
              {{bookingInfo?.tourBookingInfo?.totalNoOfWheelchairs}}</label>
          </div>
        </div>

        <div class="col-12 grid p-0 pl-2">
          <div class="col-12 md:col-7 lg:col-7">
            <label class="subLabel" translate>label_luggage_bags_required</label>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <label class="lbl-bold">
              {{bookingInfo?.tourBookingInfo?.totalNoOfLuggageBags}}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mt-3 flex justify-content-start align-items-center pl-0">
      <div class="start-point-new"><img src="/assets/images/temp/disclaimer.svg"></div>
      <div class="disclaimerLabel ml-3" translate>label_disclaimer_popup</div>
    </div>

    <div class="form-field col-12 md:col-12 lg:col-12 manual-booking pl-0">
      <div class="form-control">
        <p-radioButton class="radioStyle p-0 mr-5" name="approve" [(ngModel)]="approve" value="true"
          label="Approve Passenger With / Without Luggage" (onClick)="isPassengerCountClicked('true')">
        </p-radioButton>

        <div class="form-field grid col-12 md:col-12 lg:col-12 child-seat-div pb-0 ml-06" *ngIf="approve == 'true'">
          <div class="grid passengerGreyBox col-6 md:col-6 lg:col-6 m-2 maxWidth p-0">
            <div class="col-8 md:col-8 lg:col-8 pad-right-0px block-sub-heading pb-0 mt-04">
              <label class="other_details_section_labels" translate>label_passenger_request_count</label>
            </div>
            <div
              class="col-4 md:col-4 lg:col-4 seat-add-rm-btn-div grid flex justify-content-end align-items-center pb-0">
              <div class="col-4 md:col-4 lg:col-4">
                <button class="taxipulse-theme-button plus_minus_button_design floatRight buttonStyle" pButton appRipple
                  (click)="onRemovePassenger()" icon="fa fa-minus" [disabled]="passengerRequestCount == 1">
                </button>
              </div>
              <div class="col-4 md:col-4 lg:col-4 text-right counter floatRight p-0">
                {{passengerRequestCount}}
              </div>
              <div class="col-4 md:col-4 lg:col-4 pad-lft-0px non-selectable">
                <button class="taxipulse-theme-button plus_minus_button_design floatRight buttonStyle" pButton appRipple
                  (click)="onAddPassenger($event)" icon="fa fa-plus"
                  [disabled]="passengerRequestCount == 2 || bookingInfo?.tourBookingInfo?.totalNoOfPassengers == 1 || bookingInfo?.tourBookingInfo?.subServiceType === 'SHUTTLE'">
                </button>
              </div>
            </div>
          </div>

          <div class="grid passengerGreyBox col-6 md:col-6 lg:col-6 m-2 ml-0 maxWidth p-0">
            <div class="col-8 md:col-8 lg:col-8 pad-right-0px block-sub-heading pb-0 mt-04">
              <label class="other_details_section_labels" translate>label_luggage_request_count</label>
            </div>
            <div
              class="col-4 md:col-4 lg:col-4 seat-add-rm-btn-div grid flex justify-content-end align-items-center pb-0">
              <div class="col-4 md:col-4 lg:col-4">
                <button class="taxipulse-theme-button plus_minus_button_design floatRight buttonStyle" pButton appRipple
                  (click)="onRemoveLuggage()" icon="fa fa-minus" [disabled]="luggageRequestCount == 0">
                </button>
              </div>
              <div class="col-4 md:col-4 lg:col-4 text-right counter floatRight p-0">
                {{luggageRequestCount}}
              </div>
              <div class="col-4 md:col-4 lg:col-4 pad-lft-0px">
                <button class="taxipulse-theme-button plus_minus_button_design floatRight buttonStyle" pButton appRipple
                  (click)="onAddLuggage()" icon="fa fa-plus"
                  [disabled]="luggageRequestCount == 1 || bookingInfo?.tourBookingInfo?.totalNoOfLuggageBags == 0">
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="grid col-12 md:col-12 lg:col-12 width70 margin07 -mt-3" *ngIf="approve == 'true'">

          <div class="col-6 md:col-6 lg:col-6 width70"><small class="textColor"
              *ngIf="bookingInfo?.tourBookingInfo?.totalNoOfPassengers == 1">Note: To select passenger vehicle count,
              the number of passenger's must be greater than 1.</small></div>
          <div class="col-6 md:col-6 lg:col-6 width70"><small class="textColor"
              *ngIf="bookingInfo?.tourBookingInfo?.totalNoOfLuggageBags == 0">Note: To select luggage vehicle count, the
              number of bags must be greater than 0.</small></div>
        </div>
      </div>

      <div class="form-control">
        <p-radioButton class="radioStyle p-0 mr-5" name="decline" [(ngModel)]="decline" value="false" label="Decline"
          (onClick)="isPassengerCountClicked('false')">
        </p-radioButton>

        <div class="form-field col-11 md:col-11 lg:col-11 child-seat-div note m-2 p-2 minMaxWidth"
          *ngIf="decline == 'false'">
          <label class="other_details_section_labels" translate>luggage_request_popup</label>
        </div>
      </div>
    </div>

    <div class="col-12 flex justify-content-end align-items-center pr-4 pad-r-1p7rem">
      <button class="cancel_button mr-3" pButton appRipple type="button" label="Cancel"
        (click)="onClickBack()"></button>
      <button class="book_request_button" pButton appRipple type="button" label="Submit"
      [disabled]="isSubmitting" (click)="onClickBookNow()"></button>
    </div>
  </ng-template>
</p-dialog>

<app-merge-booking-popup
  (onMergeComplete)="onMergeComplete($event)"
  (onClose)="onMergePopupClose()">
</app-merge-booking-popup>

<app-cancellation-reason-popup
  [(visible)]="showCancellationReasonPopup"
  [selectedBookingForCancellation]="selectedBookingForCancellation"
  [eventId]="eventIdParam"
  (onConfirm)="onCancellationConfirm($event)"
  (onCancel)="closeCancellationReasonPopup()">
</app-cancellation-reason-popup>